<template>
  <div class="copy-right-container">
    <div style="text-align: center">Oasisdoctor.cn 版权所有 相关经营资质证书：<a href="https://beian.miit.gov.cn" target="_blank" style="font-size: inherit;color: inherit">黔ICP备20001840号-4</a></div>
  </div>
</template>

<script>
export default {
  name: 'AppFooterCopyRight',
  data() {
    return {}
  },
  computed: {
    userName: function () {
      return ''
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    doSomething() {
    }
  }
}
</script>

<style scoped>
.copy-right-container {
  height: 66px;
  line-height: 66px;
  color: white;
  font-size: 16px;
  background-color: #353b47;
  margin: 0 auto;
  position: relative;
}

@media only screen and (min-width: 992px) {
  .copy-right-container {
    width: 992px;
  }
}

@media only screen and (min-width: 1200px) {
  .copy-right-container {
    width: 1200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppFooterCopyRight.vue